import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneFlowActionEvaluator = createAsyncThunk(
  "FlowActionEvaluator/GetOneFlowActionEvaluator",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionEvaluator/GetOneFlowActionEvaluator",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateFlowActionEvaluator = createAsyncThunk(
  "FlowActionEvaluator/UpdateFlowActionEvaluator",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionEvaluator/UpdateFlowActionEvaluator",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ChangeStatusAndEditFlowActionEvaluator = createAsyncThunk(
  "Evaluator/ChangeStatusAndEditFlowActionEvaluator",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/Evaluator/ChangeStatusAndEditFlowActionEvaluator",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "appvvvv");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetShortListNumbers = createAsyncThunk(
  "Evaluator/GetShortListNumbers",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/Evaluator/GetShortListNumbers",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const FlowActionEvaluator = createSlice({
  name: "FlowActionEvaluator",
  initialState: {
    //------------- GetOneFlowActionEvaluator ---------------------
    FlowActionEvaluator: {},
    loadingFlowActionEvaluator: false,
    errorFlowActionEvaluator: null,
    //------------- UpdateFlowActionEvaluator ---------------------
    FlowActionEvaluatorUpdate: {},
    loadingFlowActionEvaluatorUpdate: false,
    errorFlowActionEvaluatorUpdate: null,
     //------------- ChangeStatusAndEditFlowActionEvaluator ---------------------
    ChangeStatusAndFlow: {},
    loadingChangeStatusAndFlow: false,
    errorChangeStatusAndFlow: null,
      //------------- GetShortListNumbers ---------------------
    ShortListNumbers: {},
    loadingShortListNumbers: false,
    errorShortListNumbers: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneFlowActionEvaluator.pending, (state, action) => {
        state.loadingFlowActionEvaluator = true;
        state.FlowActionEvaluator = action.payload;
        state.errorFlowActionEvaluator = null;
      })
      .addCase(GetOneFlowActionEvaluator.fulfilled, (state, action) => {
        state.loadingFlowActionEvaluator = false;
        state.FlowActionEvaluator = action.payload;
      })
      .addCase(GetOneFlowActionEvaluator.rejected, (state, action) => {
        state.loadingFlowActionEvaluator = false;
        state.FlowActionEvaluator = action.payload;
      });
   //----------------------AddflowActionScientificCommittee---------------------
     builder
      .addCase(UpdateFlowActionEvaluator.pending, (state, action) => {
        state.loadingFlowActionEvaluatorUpdate = true;
        state.FlowActionEvaluatorUpdate = action.payload;
        state.errorFlowActionEvaluatorUpdate = null;
      })
      .addCase(UpdateFlowActionEvaluator.fulfilled, (state, action) => {
        state.loadingFlowActionEvaluatorUpdate = false;
        state.FlowActionEvaluatorUpdate = action.payload;
      })
      .addCase(UpdateFlowActionEvaluator.rejected, (state, action) => {
        state.loadingFlowActionEvaluatorUpdate = false;
        state.FlowActionEvaluatorUpdate = action.payload;
      });
   //----------------------ChangeStatusAndEditFlowActionEvaluator---------------------
     builder
      .addCase(ChangeStatusAndEditFlowActionEvaluator.pending, (state, action) => {
        state.loadingChangeStatusAndFlow = true;
        state.ChangeStatusAndFlow = action.payload;
        state.errorChangeStatusAndFlow = null;
      })
      .addCase(ChangeStatusAndEditFlowActionEvaluator.fulfilled, (state, action) => {
        state.loadingChangeStatusAndFlow = false;
        state.ChangeStatusAndFlow = action.payload;
      })
      .addCase(ChangeStatusAndEditFlowActionEvaluator.rejected, (state, action) => {
        state.loadingChangeStatusAndFlow = false;
        state.ChangeStatusAndFlow = action.payload;
      });
     //----------------------GetShortListNumbers---------------------
     builder
      .addCase(GetShortListNumbers.pending, (state, action) => {
        state.loadingShortListNumbers = true;
        state.ShortListNumbers = action.payload;
        state.errorShortListNumbers = null;
      })
      .addCase(GetShortListNumbers.fulfilled, (state, action) => {
        state.loadingShortListNumbers = false;
        state.ShortListNumbers = action.payload;
      })
      .addCase(GetShortListNumbers.rejected, (state, action) => {
        state.loadingShortListNumbers = false;
        state.ShortListNumbers = action.payload;
      });
   
   
  },
});


export default FlowActionEvaluator.reducer;
